import {
  SectionCard,
  SectionCardSubTitle,
  SectionCardTitle,
} from "@/components";
import { slide } from "./consts";

const Certification = () => {
  return (
    <section className="bg-[#F9F9F9] bg-no-repeat bg-center bg-cover">
      <SectionCard className="flex flex-col items-center justify-center text-white">
        <SectionCardSubTitle className="text-[#335162]">
          Our Pride Moment
        </SectionCardSubTitle>
        <SectionCardTitle className="lg:w-full mb-10 mt-5 text-[#00192C] text-center">
          Certifications and Recognitions
        </SectionCardTitle>

        {/* Running Cards */}
        <div className="w-full overflow-hidden mb-10">
          <div className="flex gap-6 animate-infinite-scroll">
            {slide.concat(slide).map((data: string, i: number) => (
              <div
                key={i}
                className="flex items-center justify-center flex-shrink-0 bg-white rounded-xl shadow-md border border-gray-200 p-4 w-[160px] h-[130px]"
              >
                <img
                  src={data}
                  className="max-h-full max-w-full object-contain"
                  alt={`cert-${i}`}
                />
              </div>
            ))}
          </div>
        </div>
      </SectionCard>
    </section>
  );
};

export default Certification;
